import styled from "styled-components";

export const SCreateProjectCardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
